__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-31-1785498722-stable-dev/";